import PropTypes from 'prop-types'
import React from 'react'

const OrderSearch = ({ searchString, onChange, styles = null, isConsolidate = false }) => (
  <div className='c-form c-form--search' style={{ marginTop: 0 }}>
    <div className='form-group' style={styles}>
      <i className='icon-search'></i>
      <input
        className='form-control'
        placeholder={
          isConsolidate
            ? 'Search Name / Mobile Number'
            : 'Search Name / Mobile Number / Order Reference'
        }
        type='text'
        value={searchString}
        onChange={onChange}
      />
    </div>
  </div>
)

OrderSearch.propTypes = {
  searchString: PropTypes.string,
  setSearchString: PropTypes.func,
}

export default OrderSearch
